import { Route, Routes, useLocation } from "react-router-dom";
import RootPage from "./RootPage";
import OrderPage from "./components/OrderPage/OrderPage";
import CartPage from "./components/CartPage/CartPage";
import React from "react";
import DataService from "./service/DataService";
import { ThemeProvider } from "./hooks/ThemeContext";
import OrderConfirmationPage from "./components/CartPage/OrderConfirmationPage";
import Terms from "./components/Legal/Terms";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";
import LinkPage from "./components/LinkPage/LinkPage";
import { useConfig } from "./hooks/ConfigProvider";
import { useRestaurant } from "./hooks/RestaurantContext";
import RestaurantsPage from "./components/RestaurantsPage/RestaurantsPage";
import NoRestaurantSelected from "./components/RestaurantsPage/NoRestaurantSelected";
import TimeService from "./service/TimeService";
import RestaurantUnavailable from "./components/RestaurantsPage/RestaurantUnavailable";
import OrderHistoryPage from "./components/OrderHistory/OrderHistoryPage";
import AccountPage from "./components/Account/AccountPage";
import Spinner from "./components/Spinner/Spinner";
import { getRemoteEnv, isSingleStore } from './config/remoteEnv';
import RewardsPage from "./components/RewardsPage/RewardsPage";
import { fetchLoyaltyPublicConfig } from "./service/LoyaltyService";
import { resolveOnlineMenu, resolveOnlineMenuSettings } from "./service/MenuGroups";
import { OrderModeProvider, resolveOrderMode } from "./hooks/OrderModeContext";

// Lazy: ImageCompressor drags in heic2any (~1.3MB) which customers never use.
const ImageCompressor = React.lazy(() => import("./components/AssetComponents/ImageCompressor"));

type Props = {
  testMode?: boolean
}


const RoutePageRoutes = (props: Props) => {

      console.log("=== ROUTEPAGEROUTES RENDER ===");
    console.log("testMode:", props.testMode);
    console.log("window.location.pathname:", window.location.pathname);

    // RAW menu data as loaded; the channel + fulfilment-mode resolution is
    // DERIVED below so a mode switch reprices menu and cart together.
    const [rawMenu, setRawMenu] = React.useState<any[]>([]);
    const [rawMenuSettings, setRawMenuSettings] = React.useState<any[]>([]);
    const [menuLoading, setMenuLoading] = React.useState(true);
    const [openingHours, setOpeningHours] = React.useState<any[]>([]);
    const [additionalCharges, setAdditionalCharges] = React.useState([]);
    const { config } = useConfig();
    const [singleStoreConfig, setSingleStoreConfig] = React.useState<any>();
    const [activeUserId, setActiveUserId] = React.useState("");
    // Loyalty rewards: the tab only shows when the brand has loyalty on.
    const [loyaltyOn, setLoyaltyOn] = React.useState(false);

    const location = useLocation();

    // const [cart, setCart] = React.useState(() => {
    //   const savedCart = localStorage.getItem("dp-appId-cart");
    //   return savedCart ? JSON.parse(savedCart) : [];
    // });
    const [cart, setCart] = React.useState<any>(() => {
      // Don't try to load from localStorage during initial render
      // since restaurantId might not be available yet
      return [];
    });

    // const [showTopbar, setShowTopbar] = React.useState(false);
    // const [showSidebar, setShowSidebar] = React.useState(false);
    // const [homePageMode, setHomePageMode] = React.useState(false);


    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const restaurantId = queryParams.get("r") || config.defaultRestaurantId;
    const { restaurantId } = useRestaurant();

    // ── Menu freshness ────────────────────────────────────────────────────
    // The boot config caches the menu (sessionStorage, 60s) and nothing
    // refetched it afterwards — a long-lived tab showed stale prices until
    // a full new browser session. Same discipline as the POS now: refresh
    // immediately on mount, every 60s, and whenever the tab regains
    // visibility (covers iOS restoring tabs without re-running boot).
    React.useEffect(() => {
      if (!restaurantId) return;
      let live = true;
      let lastFetch = 0;
      const refresh = async () => {
        if (Date.now() - lastFetch < 5_000) return; // visibility + pageshow double-fire guard
        lastFetch = Date.now();
        try {
          const appId = getRemoteEnv().appId;
          const res = await fetch(`https://www.dineplatform.com/r/${appId}/restaurants.json?_=${Date.now()}`);
          if (!res.ok) return;
          const all = await res.json();
          const rd = all?.[restaurantId];
          if (!live || !rd) return;
          setRawMenu((prev: any[]) => JSON.stringify(prev) === JSON.stringify(rd.menu || []) ? prev : (rd.menu || []));
          setRawMenuSettings((prev: any[]) => JSON.stringify(prev) === JSON.stringify(rd.menuSettings || []) ? prev : (rd.menuSettings || []));
        } catch { /* offline — next tick retries */ }
      };
      const t = window.setInterval(refresh, 60_000);
      const onVisible = () => { if (document.visibilityState === "visible") void refresh(); };
      document.addEventListener("visibilitychange", onVisible);
      window.addEventListener("pageshow", onVisible);
      void refresh();
      return () => {
        live = false;
        window.clearInterval(t);
        document.removeEventListener("visibilitychange", onVisible);
        window.removeEventListener("pageshow", onVisible);
      };
    }, [restaurantId]);

    // The active fulfilment mode, resolved with the SAME pure function the
    // OrderModeProvider uses — same render, same answer. The menu is baked
    // from it, so a price for the wrong mode can never render (the menu is
    // gated behind mode selection anyway).
    const activeOrderMode = resolveOrderMode({
      search: location.search,
      pathname: location.pathname,
      storeConfig: singleStoreConfig,
      restaurantId,
    });

    const productData = React.useMemo(
      () => resolveOnlineMenu(rawMenu, rawMenuSettings, activeOrderMode),
      [rawMenu, rawMenuSettings, activeOrderMode]
    );
    const menuSettings = React.useMemo(
      () => resolveOnlineMenuSettings(rawMenuSettings, activeOrderMode),
      [rawMenuSettings, activeOrderMode]
    );

    // const [backgroundColor, setBackgroundColor] = React.useState("black");
    // const []

  // React.useEffect(() => {
  //   console.log("HOME PAGE MODE UPDATED: ", homePageMode)
  // }, [homePageMode])

  const setMenu = (e: any) => {
    console.log("setMenu call, restaurantID: " + JSON.stringify(restaurantId));

    if (e && e.data) {
      setRawMenu(e.data.menu || []);
      setRawMenuSettings(e.data.menuSettings || []);
      setMenuLoading(false)
      // setOpeningHours(e.data.openingHours);
      // setAdditionalCharges(e.data.additionalCharges)
    }
    
    // let localData = localStorage.getItem("dp-appId-cart") || "";
    // if (localData !== "") {
    //   setCart(JSON.parse(localData));
    // }
  }

  const setCharges = (e: any) => {
    if (e && e.data) {
      setAdditionalCharges(e.data.additionalCharges)
    }
  }


  React.useEffect(() => {
    console.log("inside use effect")
    if (restaurantId){

      console.log(getRemoteEnv().appId)

      const allRestaurantData = getRemoteEnv().restaurantData;
      const restaurantData = allRestaurantData?.[restaurantId];

      if (restaurantData) {
        setRawMenu(restaurantData.menu || []);
        setRawMenuSettings(restaurantData.menuSettings || []);
        setMenuLoading(false);
      } else {
        // Fallback to DataService if not in remoteEnv
        DataService.GetData("restaurants", restaurantId, undefined, setMenu).then((result) => {
          if (result) {
            setRawMenu(result.menu || []);
            setRawMenuSettings(result.menuSettings || []);
            setMenuLoading(false);
          }
        });
      }

      // DataService.addData("restaurants", myData, undefined, restaurantId)

      // DataService.GetData("restaurants", restaurantId, undefined, setMenu).then((result) => {
      //     if (result) {
      //       setProductData(result.menu);
      //       setMenuSettings(result.menuSettings);
      //       setMenuLoading(false)
      //       // setOpeningHours(result.openingHours);
      //     }
      // });

      // const fetchMenu = async () => {
      //   try {
      //     const appId = getRemoteEnv().appId;
      //     const res = await fetch(
      //       `https://www.dineplatform.com/r/${appId}/restaurants.json?_=${Date.now()}`
      //     );
      //     if (!res.ok) throw new Error(`HTTP ${res.status}`);
      //     const data = await res.json();
      //     const restaurantData = data[restaurantId];
      //     if (!restaurantData) throw new Error("Restaurant not found in response");
      //     setProductData(restaurantData.menu);
      //     setMenuSettings(restaurantData.menuSettings);
      //     setMenuLoading(false);
      //   } catch (e) {
      //     DataService.GetData("restaurants", restaurantId, undefined, setMenu).then((result) => {
      //       if (result) {
      //         setProductData(result.menu);
      //         setMenuSettings(result.menuSettings);
      //         setMenuLoading(false);
      //       }
      //     });
      //   }
      // };

      // fetchMenu();

      DataService.GetData("storeConfig", restaurantId, undefined, setCharges).then((result) => {
        if (result) {
          // console.log("SOURCE: " + restaurantId + " " + JSON.stringify(result.additionalCharges))
          setSingleStoreConfig(result);
          setAdditionalCharges(result.additionalCharges);
          let hoursArray: any[] = [];

          if (result.delivery.enabled) {
            hoursArray.push(result.delivery.timings)
          }
          if (result.pickup.enabled) {
            hoursArray.push(result.pickup.timings)
          }
          if (result.dinein.enabled) {
            hoursArray.push(result.dinein.timings)
          }

          console.log("hours array: ", hoursArray)
          setOpeningHours(hoursArray)
        }
    });

      // Menu-only sites never show Rewards — there's no ordering to earn or
      // redeem with.
      if (getRemoteEnv().menuOnly) {
        setLoyaltyOn(false);
      } else {
        fetchLoyaltyPublicConfig(restaurantId)
          .then((c) => setLoyaltyOn(c.enabled === true))
          .catch(() => setLoyaltyOn(false));
      }

      const storageKey = `dp-appId-cart-${restaurantId}`;
      console.log("getting cart: ", storageKey)
      // Load initial cart data when restaurantId becomes available
      const savedCart = localStorage.getItem(storageKey);
      if (savedCart) {
        setCart(JSON.parse(savedCart));
      }

    }
  }, [restaurantId])

  React.useEffect(() => {
    if (restaurantId) {
      const storageKey = `dp-appId-cart-${restaurantId}`;
      localStorage.setItem(storageKey, JSON.stringify(cart));
    }
  }, [cart, restaurantId]);

  const [sidebarPages, setSidebarPages] = React.useState<any[]>([])

  React.useEffect(() => {

    let cartText = "Cart";
    if (cart.length > 0) {
      cartText = `Cart (${cart.length})`;
    }

    if (!isSingleStore()) {

        setSidebarPages([
          {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
          // {buttonText: "Home", url: process.env.REACT_APP_HOME_STORE_URL, iconName: "HiHome"},
          {buttonText: "Order", url: ["/order", "/pickup", "/dinein"], iconName: "HiPencilAlt"},
          ...(loyaltyOn ? [{buttonText: "Rewards", url: ["/rewards"], iconName: "HiGift"}] : []),
          // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
          // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
          // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
          {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
          {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
        ])


      // if (props.testMode) {
      //   setSidebarPages([
      //     // {buttonText: "Home", url: process.env.REACT_APP_HOME_STORE_URL, iconName: "HiHome"},
      //     {buttonText: "Home", url: ["/test", "/test/restaurants"], iconName: "HiHome"},
      //     {buttonText: "Order", url: ["/test/order", "/test/pickup", "/test/dinein"], iconName: "HiPencilAlt"},
      //     // {buttonText: "Find Us", url: "/test/location", iconName: "HiLocationMarker"},
      //     // {buttonText: "Contact", url: "/test/contact", iconName: "HiPhone"},
      //     {buttonText: "History", url: ["/test/recent"], iconName: "HiClock"},
      //     {buttonText: "Account", url: ["/test/account"], iconName: "HiUserCircle"},
      //   ])
      // }
      // else {
      //   setSidebarPages([
      //     {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
      //     // {buttonText: "Home", url: process.env.REACT_APP_HOME_STORE_URL, iconName: "HiHome"},
      //     {buttonText: "Order", url: ["/order", "/pickup", "/dinein"], iconName: "HiPencilAlt"},
      //     // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
      //     // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
      //     // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
      //     {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
      //     {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
      //   ])
      // }
    }
    else {

        let remoteConfig = getRemoteEnv();

        if (remoteConfig.homeStoreUrl) {
          setSidebarPages([
            // {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
            {buttonText: "Home", url: remoteConfig?.homeStoreUrl || "", iconName: "HiHome"},
            {buttonText: "Order", url: ["/", "/order"], iconName: "HiPencilAlt"},
            ...(loyaltyOn ? [{buttonText: "Rewards", url: ["/rewards"], iconName: "HiGift"}] : []),
            // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
            // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
            // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
            {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
            {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
          ])
        }
        else {
          setSidebarPages([
            // {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
            // {buttonText: "Home", url: config.properties.homeStoreUrl || "", iconName: "HiHome"},
            {buttonText: "Order", url: ["/", "/order"], iconName: "HiPencilAlt"},
            ...(loyaltyOn ? [{buttonText: "Rewards", url: ["/rewards"], iconName: "HiGift"}] : []),
            // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
            // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
            // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
            {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
            {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
          ])
        }

      // if (props.testMode) {
      //   setSidebarPages([
      //     {buttonText: "Home", url: config?.properties?.homeStoreUrl || "", iconName: "HiHome"},
      //     // {buttonText: "Home", url: ["/test", "/test/restaurants"], iconName: "HiHome"},
      //     {buttonText: "Order", url: ["/test", "/test/order"], iconName: "HiPencilAlt"},
      //     // {buttonText: "Find Us", url: "/test/location", iconName: "HiLocationMarker"},
      //     // {buttonText: "Contact", url: "/test/contact", iconName: "HiPhone"},
      //     // {buttonText: cartText, url: "/test/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
      //     {buttonText: "History", url: ["test/recent"], iconName: "HiClock"},
      //     {buttonText: "Account", url: ["/test/account"], iconName: "HiUserCircle"},
      //   ])
      // }
      // else {
      //   if (config && config?.properties?.homeStoreUrl) {
      //     setSidebarPages([
      //       // {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
      //       {buttonText: "Home", url: config?.properties?.homeStoreUrl || "", iconName: "HiHome"},
      //       {buttonText: "Order", url: ["/", "/order"], iconName: "HiPencilAlt"},
      //       // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
      //       // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
      //       // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
      //       {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
      //       {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
      //     ])
      //   }
      //   else {
      //     setSidebarPages([
      //       // {buttonText: "Home", url: ["/", "/restaurants"], iconName: "HiHome"},
      //       // {buttonText: "Home", url: config.properties.homeStoreUrl || "", iconName: "HiHome"},
      //       {buttonText: "Order", url: ["/", "/order"], iconName: "HiPencilAlt"},
      //       // {buttonText: "Find Us", url: "/location", iconName: "HiLocationMarker"},
      //       // {buttonText: "Contact", url: "/contact", iconName: "HiPhone"},
      //       // {buttonText: cartText, url: "/cart", iconName: "HiShoppingCart", hideInDesktopView: true},
      //       {buttonText: "History", url: ["/recent"], iconName: "HiClock"},
      //       {buttonText: "Account", url: ["/account"], iconName: "HiUserCircle"},
      //     ])
      //   }
      // }
    }
  }, [cart, loyaltyOn])


  const renderOrderPage = () => {
        console.log("=== renderOrderPage called ===");
    console.log("restaurantId:", restaurantId);
    console.log("menuLoading:", menuLoading);
    console.log("menuSettings.length:", menuSettings.length);
    const searchParams = new URLSearchParams(location.search);
    const rValue = searchParams.get('r');

    if (!rValue && restaurantId === '') {
      console.log("no restaurant selected")
      return <NoRestaurantSelected />;
    }
    else {
      console.log("order page found", restaurantId)
      console.log("menu settings: ", menuSettings)
      if (!menuLoading && menuSettings.length === 0) {
        console.log("restaurant unavailable")
        return <RestaurantUnavailable />;     
      }
      else if (menuLoading){
        return (
          <div style={{display: "flex", width: "100%", minHeight: "60vh", alignItems: "center", justifyContent: "center"}}>
            <Spinner />
          </div>
        )
      }
      else {
        return (
          <OrderPage 
            cart={cart} 
            setCart={setCart} 
            menuSettings={menuSettings} 
            openingHours={openingHours} 
            productData={productData || []} 
            additionalCharges={additionalCharges} 
            testMode={props.testMode || false}
            singleStoreConfig={singleStoreConfig}
          />
        );
      }
    }
  };


    return (
      <OrderModeProvider storeConfig={singleStoreConfig}>
      <ThemeProvider>
        {/* Test Mode Notification - Bottom */}
        {/* {(props.testMode || singleStoreConfig?.stripeLiveId === "" || false) && (
          <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#fbbf24',
            color: '#78350f',
            padding: '12px 16px',
            textAlign: 'center',
            fontWeight: '600',
            zIndex: 9999,
            boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
          }}>
            ⚠️ This application is currently in TEST mode. Any orders will not be processed.
          </div>
        )} */}

        <RootPage
            sidebarPages={sidebarPages}
            hideLogo={false}
            showSidebar
            cartCount={cart.length}
        >

                {console.log("=== INSIDE ROOTPAGE ===")}
      {console.log("About to render Routes")}
      {/* {console.log("config.properties.type:", config.properties.type)} */}


          <Routes>
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            {/* Customer-display QR: link the customer's email to one POS order. */}
            <Route path="/link" element={<LinkPage />} />
            {/* <Route path="/" element={<SitesPage activeUserId={activeUserId} />} /> */}
            <Route path="/order" element={renderOrderPage()} />
            {/* <Route path="/" element={<OrderPage cart={cart} setCart={setCart} menuSettings={menuSettings} openingHours={openingHours} productData={productData || []} additionalCharges={additionalCharges} testMode={props.testMode || false}/>} /> */}
            
            {/* // TODO: Undo this change */}
            {/* <Route path="/" element={renderOrderPage()} /> */}
            {isSingleStore() && <Route path="/" element={renderOrderPage()} />}
            {!isSingleStore() && <Route path="/" element={<RestaurantsPage />} />}

            {process.env.REACT_APP_DISABLE_ADMIN === "false" && <Route path="/image" element={<React.Suspense fallback={<></>}><ImageCompressor /></React.Suspense>} />}
            <Route path="/restaurants" element={<RestaurantsPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/rewards" element={<RewardsPage cart={cart} setCart={setCart} productData={productData || []} testMode={props.testMode || false} />} />
            <Route path="/recent" element={<OrderHistoryPage environment={props.testMode ? "test" : "live"}/>} />
            <Route path="/pickup" element={<OrderPage cart={cart} setCart={setCart} menuSettings={menuSettings} openingHours={openingHours} productData={productData || []} additionalCharges={additionalCharges} testMode={props.testMode || false} singleStoreConfig={singleStoreConfig}/>} />
            <Route path="/dinein" element={<OrderPage cart={cart} setCart={setCart} menuSettings={menuSettings} openingHours={openingHours} productData={productData || []} additionalCharges={additionalCharges} testMode={props.testMode || false} singleStoreConfig={singleStoreConfig}/>} />
            <Route path="/orderConfirmation" element={<OrderConfirmationPage />} />
            <Route path="/cart" element={<CartPage cart={cart} setCart={setCart} menuSettings={menuSettings} openingHours={openingHours} productData={productData || []} additionalCharges={additionalCharges} testMode={props.testMode || false} singleStoreConfig={singleStoreConfig}/>} />
            {/* <Route path="/location" element={
              <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d621.1618033371224!2d-0.3107067181138064!3d51.482989594751636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760db75834c5bd%3A0x300b26c8c6d11e30!2sUnit-1%2C%20Brentford%20Lock%2C%20High%20St%2C%20Brentford%20TW8%208AQ%2C%20UK!5e0!3m2!1sen!2sin!4v1718359389686!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
            } /> */}



          </Routes>

        </RootPage>
      </ThemeProvider>
      </OrderModeProvider>
    )
}

export default RoutePageRoutes;